import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import Firebase from "./firebase"
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-145913295-1',
  router
})

Vue.use(Buefy)

Vue.config.productionTip = false

Firebase.init();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
